module.exports = __webpack_public_path__ + "static/smart-home-tablet-plp-2620fd80ffacca2b3d0d03898f70a9f8.png";